import script from "./AtividadesHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadesHome.vue?vue&type=script&setup=true&lang=js"

import "./AtividadesHome.vue?vue&type=style&index=0&id=102f2865&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102f2865"]])

export default __exports__